/**
 * The closed set of event characteristics, in the order they are always
 * shown (§ docs/EVENT_DETAIL_REDESIGN.md).
 *
 * Fixed rather than free-form on purpose: the point of these bars is that
 * two events can be compared at a glance, which only works if every event
 * is rated on the same axes. It also keeps the labels out of the content —
 * they come from the locale files, so a DE and an EN file don't each have
 * to spell "Ambiente"/"Atmosphere" and can't drift apart.
 *
 * `scripts/check-seo.js` rejects any key that isn't in this list.
 */
export const EVENT_CHARACTERISTICS = ["ambiente", "kaempfe", "magie", "raetsel", "schlachten"];

export const CHARACTERISTIC_MAX = 5;

/**
 * Frontmatter may write either `ambiente: 5` or
 * `ambiente: { value: 5, note: "…" }` — the bare number is the common
 * case and shouldn't need a wrapper object. Returns null for a key that
 * isn't set, so the row is skipped rather than implying a zero rating an
 * organiser never gave.
 */
export function readCharacteristic(characteristics, key) {
  const entry = characteristics?.[key];
  if (entry == null) return null;
  if (typeof entry === "number") return { value: entry, note: undefined };
  if (typeof entry.value !== "number") return null;
  return { value: entry.value, note: entry.note };
}
